<template>
  <div class="annuity-bar">
    <div class="bar-labels-wrap">
      <span class="text-primary bold annuity-plan-message">
        {{ labels.annuityPlan1 }}
        <br class="d-sm-none" />
        {{ labels.annuityPlan2 }}
      </span>
      <div class="text-primary text-right">
        <span class="total-message">{{ labels.total }}</span>
        <br class="d-sm-none" />
        <span class="bold">R$ {{ annuityTotal | toCurrency }}</span>
      </div>
    </div>
    <b-button
      :class="buttonOptions.classes"
      id="continue"
      variant="quartenary"
      @click="$emit('chosenAnnuity')"
      :disabled="licenses < activatedUsersCount || buttonOptions.disabled"
    >
      <slot name="button">
        {{ labels.continue }}
      </slot>
    </b-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    licenses: {
      default() {
        return 0
      },
      type: Number,
    },
    annuityPrice: {
      default() {
        return 0
      },
      type: Number,
    },
    activatedUsersCount: {
      default() {
        return 0
      },
      type: Number,
    },
    buttonOptions: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.page.home.licensesForm
    },
    annuityTotal: function() {
      return parseInt(this.licenses) * parseFloat(this.annuityPrice) * 12
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.annuity-bar {
  align-items: center;
  background: map-get($theme-colors, 'yellow');
  border: 1px map-get($theme-colors, 'gray07');
  border-radius: 0 0 8px 8px;
  display: flex;
  min-height: 80px;
  padding: 1.25rem;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 425px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  @media (max-width: 1024px) {
    padding: 0.5rem;
  }

  .bar-labels-wrap {
    align-items: center;
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    line-height: initial;
    padding: 1rem 0.5rem;

    @media (max-width: 425px) {
      padding: 1rem 1.5rem;
      width: 100%;
    }

    .total-message {
      padding-right: 15px;
    }
  }

  .btn {
    color: white;
    font-weight: 500;
    width: 100%;
    max-width: 280px;

    @media (max-width: 425px) {
      border-radius: 0 !important;
      height: 50px !important;
      max-height: 50px;
      max-width: 100%;
    }
  }
}
</style>
